import { useState } from 'react';
import { dateMethods } from '@utils/dates/dateMethods';
import { useAppSelector, environmentSelector, calculateOverrideSEPEndWithFormat } from '../utils';
import { getDateObject, isDateValid, startOf } from '@utils/dates/date.utils';
import { MM_SLASH_DD_SLASH_YYYY } from '@utils/dates/dateFormats.utils';

const useDateValidation = (gracePeriod: string = '0') => {
    const { localDates } = useAppSelector(environmentSelector);
    const [errorMsg, setErrorMsg] = useState<string | null>(null);
    const [textReplacements, setTextReplacements] = useState<string>('');

    const validateSepEndDate = (date: Date) => {
        const dateStr = dateMethods.formatDateusingIntl(date);
        
        if (isDateValid(dateStr, MM_SLASH_DD_SLASH_YYYY)) {
            const endDate = getDateObject(startOf(date, 'day'));
            const today = getDateObject(startOf(localDates.serverDate, 'day'));

            if (endDate < today) {
                setErrorMsg('cap.applications.modal.errorMsgpastDate');
            } else {
                const calculatedEndDate = calculateOverrideSEPEndWithFormat(gracePeriod).date;
                const lastDate = calculatedEndDate;

                if (endDate > lastDate) {
                    setErrorMsg('cap.applications.modal.errorMsgFutureDate');
                    setTextReplacements(dateMethods.formatDateusingIntl(lastDate));
                } else {
                    setErrorMsg(null);
                }
            }
        } else {
            setErrorMsg('cap.application.modal.overrideStartDateModal.enterValidDate');
        }
    };

    return {
        errorMsg,
        textReplacements,
        validateSepEndDate,
    };
};

export default useDateValidation;
